import type { Label } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

interface Props {
  labels: Label[];
}

export const LabelsStack = (props: Props) => {
  return (
    <ChakraV3.HStack w='full' rowGap={1}>
      {props.labels.map((label) => (
        <ChakraV3.Tag key={label.id} colorPalette={label.color} size='sm'>
          {label.name}
        </ChakraV3.Tag>
      ))}
    </ChakraV3.HStack>
  );
};
